/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/ai_medium'
export default icon
